import React from 'react';
import { Field } from 'redux-form';
import { BooleanInput, SelectInput, TextInput } from 'react-admin';
import { FormDataConsumer, required } from 'react-admin';
import { createStyles, withStyles } from '@material-ui/core/styles';

import FrequencyChoices from '../StaticData/FrequencyChoices';
import Hours from '../../../StaticData/Hours';

const ValidateRequired = required();

const styles = createStyles({
  fields: {
    width: '70%'
  },
  half_length: {
    width: '50%'
  }
});

type Props = {
  classes: any,
  record: any
};

const SettingsTab = (props: Props) => (
  <div style={{ paddingTop: 20 }}>
    <Field component={BooleanInput} label="Active" name="active" source="active" style={{ width: '0' }} />

    <Field className={props.classes.half_length} component={TextInput} label="Name *" name="name" source="name" validate={ValidateRequired} /><br />

    <div>
      <Field
        choices={FrequencyChoices}
        component={SelectInput}
        label="Frequency *"
        name="frequency"
        source="frequency"
        validate={ValidateRequired} />
    </div>

    <FormDataConsumer>
      {({ formData, ...rest }) => formData && formData.frequency === 'daily' &&
        <div>
          <Field
            choices={Hours}
            component={SelectInput}
            label="Run At *"
            name="run_at"
            source="run_at"
            translateChoice={false}
            validate={ValidateRequired} /> EST
        </div>
      }
    </FormDataConsumer>

    <FormDataConsumer>
      {({ formData, ...rest }) => formData && formData.frequency === 'hourly' &&
        <div><br />
          Monitor will be run every two hours.<br /><br />
        </div>
      }
    </FormDataConsumer>

    <div>
      <Field
        className={props.classes.fields}
        component={TextInput}
        label="Email To * (comma separated)"
        name="email_to"
        source="email_to"
        validate={ValidateRequired} />
    </div>

    <div>
      <Field
        component={BooleanInput}
        label="Email on Success (monitoring report will be sent each day)"
        name="email_on_success"
        source="email_on_success" />
    </div><br />
  </div>
);

export default withStyles(styles)(SettingsTab);



// WEBPACK FOOTER //
// ./src/views/Components/Monitors/Partials/SettingsTab.tsx